module.exports = __webpack_public_path__ + "static/media/notifications.baab8b9c.svg";